import { Box, HStack, IconButton, Shadow, Stack, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { IOProductItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';

import { DynamicIOProductTableLayoutProps } from './types';

const ItemSeparator: React.FC = () => (
  <Box
    height={Utils.Responsive.PhoneTablet({
      phone: 'stack.xxxs',
      tablet: 'stack.nano',
    })}
  />
);

export const DynamicIOProductTableMobile = <T extends IOProductItem>({
  title,
  titleDataKey,
  data,
  keyExtractor,
  detailColumns,
  footerColumns,
  onPressItem,
  renderTitle,
  renderColumnValue,
  renderTitleValue,
}: DynamicIOProductTableLayoutProps<T>) => {
  return (
    <VStack space="stack.nano" pt="stack.xxs">
      {data.map((item, index) => (
        <Box key={keyExtractor(item, index)}>
          {index > 0 && <ItemSeparator />}

          <Stack>
            <Shadow level={1} p="inset.xs" borderRadius={BoxBorder.heavy}>
              <VStack space="stack.xxxs">
                <VStack space="stack.quarck">
                  <Text color="neutral.medium" fontSize="xs">
                    {title}
                  </Text>
                  {renderTitleValue(item, titleDataKey, renderTitle, true)}
                </VStack>

                {!!detailColumns.length && (
                  <VStack space="stack.nano">
                    {detailColumns.map((column, columnIndex) => (
                      <Box key={`${String(column.dataKey)}-mobile-${columnIndex}`}>
                        <HStack justifyContent="space-between" alignItems="center">
                          <Text color="neutral.darkest">{column.mobileLabel || column.title}</Text>
                          {renderColumnValue(item, column, true)}
                        </HStack>
                        {columnIndex < detailColumns.length - 1 && (
                          <Box h="1px" w="full" bg="neutral.lightest" mt="stack.nano" />
                        )}
                      </Box>
                    ))}
                  </VStack>
                )}

                {(!!footerColumns.length || !!onPressItem) && (
                  <HStack justifyContent="space-between" alignItems="center">
                    <HStack flex={1} alignItems="center" space="inline.xxs">
                      {footerColumns.map((column, columnIndex) => (
                        <Box key={`${String(column.dataKey)}-footer-${columnIndex}`}>
                          {renderColumnValue(item, column, true)}
                        </Box>
                      ))}
                    </HStack>

                    {!!onPressItem && (
                      <IconButton
                        alignSelf="flex-end"
                        testId="dynamic-io-product-table-mobile-action"
                        icon="ArrowRight"
                        onPress={() => onPressItem(item)}
                        isDisabled={item.itemBlocked}
                        p={0}
                        backgroundColor="transparent"
                        iconColor={item.itemBlocked ? 'neutral.medium' : 'brand.tertiary.principal'}
                        iconSize="xs"
                      />
                    )}
                  </HStack>
                )}
              </VStack>
            </Shadow>
          </Stack>
        </Box>
      ))}
    </VStack>
  );
};
